<template>
  <div class="contatiner">
    <div class="bg1">
      <!-- <img class="order-title" :src="orderTitle"/> -->
      <span style="font-size: 26px;margin-top: 18%;display: inline-table;">{{goodName}}</span>
    </div>
    <div class="flex-wrap">
      <div v-if="hasQuery && address" class="box" style="margin-top: -40px;margin-bottom: 24px;"> 
        <div class="label">您的收货地址</div>
        <div class="baidu-wrap">
          {{address}}
        </div>
        <div class="help">如需改地址  请联系微信：xiaobaikaoyan001</div>
      </div>
      <div v-if="hasQuery && no" class="box">
        <div class="label">讲义快递单号查询结果</div>
        <div class="phone-wrap">
          <span>物流单号：{{no}}</span>
          <div class="copy" @click="copy($event, no)">复制</div>
        </div>
        <div class="btn-query">
          <a class="a" :href="url">点我查询物流</a>
        </div>
      </div>
      <div v-if="hasQuery && !no" class="box">
        <div class="label">快递单号查询结果</div>
        <div class="text-wrap">
          <div class="text1">当前未发货，请耐心等待</div>
          <div class="text1">按顺序发货哦~</div>
        </div>
      </div>
      <van-loading v-if="loading" size="24px" vertical>加载中...</van-loading>
      <div v-if="!hasQuery" class="box" style="margin-top: -40px;">
        <div class="label">输入收货地址手机号查询</div>
        <div class="phone-wrap">
          <span>手机号：</span>
          <input class="input" v-model="phone" />
        </div>
        <div class="btn-query" @click="query">查询</div>
        <!-- <div class="help">如需改地址  请联系微信：xiaobaikaoyan001</div> -->
      </div>
      <div class="footer">
        <div>—— 小白考研 ——</div>
        <div class="text">考研小白的成长之家</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, Field, Image, Loading, Button, Notify, NoticeBar, Grid, GridItem, Toast, Icon } from 'vant';
import https from '../../../https'
import orderTitle from '../../../../static/address-title.png'

export default {
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [NoticeBar.name]: NoticeBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon
  },
  data () {
    return {
      orderTitle,
      hasQuery: false,
      no: '',
      link:'',
      phone: '',
      goodsId: '',
      goodName: '小白收货查询',
      loading: false,
      address: ''
    };
  },
  created () {
    const goodsId = this.$route.params && this.$route.params.id
    this.goodsId = goodsId || 3
    if(this.goodsId == 3) {
      this.goodName = '小白英语收货查询'
    }
    //  else if(this.goodsId == 4) {
    //   this.goodName = '小白数学'
    // }
  },
  methods: {
    reInput () {
      this.hasQuery = false
      this.no = ''
      this.phone = ''
    },
    query () {
      var that = this
      if(!that.phone) {
        Notify({ type: 'warning', message: '手机号不能为空哦' });
        return
      }
      
      that.loading = true
      console.log(that.goodsId)
      https.fetchGet(`/api/logistics/record/find/${that.phone}?goodsId=${that.goodsId}`).then(res => {
        if (res.data && res.data.data && Object.keys(res.data.data).length>0 ) {
          that.hasQuery = true
          that.address = res.data.data.address
          that.no = res.data.data.no
          // if(that.no) that.url = that.no.startsWith("9898")?'http://yjcx.chinapost.com.cn/qps/yjcx':'https://www.zto.com/express/expressCheck.html';
          if(that.no) that.url = that.no.startsWith("YT") ? 'http://www.yto.net.cn': 'http://www.yundaex.com/cn/index.php'
          // const wp = res.data.data.wp;
          // const link = wp.split(" ")[0] || 'https://pan.baidu.com/s/1IAt4P2DwOOxT0ObcfbaLqg', ps =  wp.split(" ")[1] || '密码:u3v5'
          // this.link = link;
          // that.ps = ps
          that.loading = false
        } else {
          that.loading = false
          Notify({ type: 'warning', message: '手机号不存在，请重新输入' });
        }
      }).catch(err => {
        that.loading = false
        Notify({ type: 'warning', message: '当前人数过多，请稍后重试' });
        console.log(err)
      })

    },
    copy (e, value) {
      try {
        const input = document.createElement('textarea')
        input.value = value
        document.body.appendChild(input)
        input.select()
        document.execCommand('Copy')
        document.body.removeChild(input)
        Toast.success('复制成功');
      } catch (e) {
        Toast.fail('复制失败');
      }

    },
    feedback() {
      https.fetchPostToken(`/api/logistics/feedback`, { content: '链接失效', type: '链接失效'}).then(res => {
        if (res.data && res.data.data) {
         Notify({ type: 'success', message: '已反馈哦' });
        }
      }).catch(err => {
        Notify({ type: 'warning', message: '反馈提交失败' });
        console.log(err)
      })

    },
  }
};
</script>

<style scoped lang="less">
  .van-loading--vertical{
    position: absolute;
    z-index: 9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .contatiner{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: linear-gradient(to bottom, #FFF6E3, #FFE096);
    .bg1{
      width: 100%;
      height: 32vh;
      background: url(../../../../static/bg1.png);
      background-size: 100% 100%;
      text-align: center;;
      .order-title{
        width:  235px;
        height: 74px;
        margin-top: 40px;
      }
    }
    .flex-wrap{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .box{
        width:92vw;
        background:rgba(255,255,255,1);
        border-radius:18px;
        margin: 0 auto;
        padding-bottom: 24px;
        .text-wrap{
          padding-bottom: 32px;
          .text1{
            text-align: center;
            color: #929292;
            &:first-child{
              padding-bottom: 10px;
            }
          }
        }
        .label{
          margin: 0 auto;
          padding-top: 35px;
          padding-bottom: 36px;
          text-align: center;
          font-size: 18px;
          color: #333333;
        }
        .baidu-wrap{
          width: 290px;
          padding: 15px;
          margin: 0 auto;
          background: #F3F3F3;
          color: #333;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          .baidu{
            font-size: 15px;
          }
          .link{
            color: #0091FF;
            word-break: break-all;
          }
        }
        .phone-wrap{
          position: relative;
          display: flex;
          align-items: center;
          padding-left: 14px;
          width: 290px;
          height: 56px;
          margin: 0 auto;
          background: #F3F3F3;
          .copy{
            position: absolute;
            right: 24px;
            top: 50%;
            transform: translateY(-50%);
            color: #3F94FF;
            font-size: 16px;
          }
          .input{
            flex: 1;
            height: 100%;
            border-width: 0;
            padding-left: 8px;
            background: transparent;
          }
        }
        .btn-query{
          width:290px;
          height:44px;
          margin: 0 auto;
          margin-top: 36px;
          line-height: 44px;
          text-align: center;
          background:linear-gradient(270deg,rgba(255,95,31,1) 0%,rgba(255,136,68,1) 100%);
          box-shadow:0px 5px 9px 0px rgba(255,153,80,0.46);
          border-radius:22px;
          color: #ffffff;
          font-size: 18px;
          .a{
            color: #ffffff;
            font-size: 18px;
          }
        }
        .btn-copy{
          width: 156px;
          margin-top: 24px;
        }
        .feedback{
          font-size: 14px;
          padding-top: 20px;
          color: #FF6322;
          text-align: center;
        }
      }
      .footer{
        margin: 0 auto;
        padding-top: 24px;
        padding-bottom: 40px;
        text-align: center;
        color: #9A6A39;
        .text{
          padding-top: 8px;
          text-align: center;
          font-size: 12px;
        }
      }

    }
    .help{
      margin-top: 20px;
      text-align: center;
      font-size: 14px;
      color: #545454;
    }
  }
</style>
